import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SocketState } from '../../../context/SocketProvider'
import { SelectTimeSlot } from '../../../redux/2d-slice/gameInfo2dSlice'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import ModalContainer from "../../../2d-game/modals/ModalContainer";
import { useNavigate } from 'react-router-dom'

function ReprintModal() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { socket } = SocketState()
    let TimeSlot = useSelector(SelectTimeSlot)

    useEffect(() => {
        dispatch(SET_MAIN_LOADER(true))
        // socket.emit('req', { "en": "MINI_LOTTERY_ADVANCE_DRAW_TIME_SLOT", "data": {} })
        socket.emit('req', { "en": "LUCKY_SORAT_GET_BET_LISTS", "data": {} })

        // socket.emit('req', {
        //     "en": "MINI_LOTTERY_FILTER_RESULTS_HISTORY",
        //     "data": {
        //         "series": "3"
        //     }
        // })
    }, [])

    // let getTicketsList = (time) => {
    //     let data = {
    //         "en": "MINI_LOTTERY_GET_BET_LISTS",
    //         "data": {
    //             "time": time
    //         }
    //     }
    //     socket.emit("req", data);
    //     dispatch(SET_MAIN_LOADER(true))
    // }

    return (
        <ModalContainer title={'RePrint'} navigation={'/titli'}>
            <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-20vh)] overflow-y-auto'>
                {/* {TimeSlot?.map((time, index) => {
                    return (
                        <div className='w-1/6 px-1 py-1.5' key={index}>
                            <div className={`border-2 py-3 rounded-lg border-gray-300 flex items-center justify-center cursor-pointer hover:bg-[#e54859] hover:text-white ${time.disable ? 'bg-gray-400' : 'bg-[#fff]'}`}
                                onClick={() => {
                                    getTicketsList(time.time)
                                }}
                            >
                                <p className='font-semibold text-[17px] hover:text-white'>{time.time}</p>
                            </div>
                        </div>
                    )
                })} */}

            </div>


        </ModalContainer>
    )
}

export default ReprintModal